







import { defineComponent, computed, ref, watch } from '@vue/composition-api'
import { useStore as useTextbookStore } from '@/shared/state-management/textbookStore'
import NavigationTabs from '@/components/custom/NavigationTabs.vue'

export default defineComponent({
  name: 'TextbooksIndex',
  components: {
    NavigationTabs,
  },
  setup(props, { root }) {
    const tabsElement = ref(null)
    const tabs = computed(() => {
      const params = {
        textbookId: root.$route.params.textbookId,
      }
      return [
        {
          name: root.$t('mediaLibrary.title'),
          icon: 'mdi-folder-multiple-image',
          to: { name: 'MediaLibraryPage', params },
        },
        {
          name: root.$t('routes.TextbookIssues', params),
          icon: 'mdi-book-open-page-variant',
          to: { name: 'TextbookIssues', params },
        },
        {
          name: root.$t('routes.Volumes', params),
          icon: 'mdi-book-multiple',
          to: { name: 'Volumes', params },
        },
        {
          name: root.$t('routes.Categories'),
          icon: 'mdi-bookmark-multiple',
          to: { name: 'Categories', params },
        },
      ]
    })
    const { activeTextbook } = useTextbookStore().getters

    watch(
      () => activeTextbook.value,
      () => {
        setTimeout(() => tabsElement.value.updateSlider(), 1000)
      }
    )

    return { tabs, tabsElement }
  },
})
